// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__bBgf3","text":"Welcome_text__puZoq","model":"Welcome_model__0cRsU"};